import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { ModalService } from '@services/modal/modal.service';
import { DateRangePickerMobileModalComponent } from './date-range-picker-mobile-modal/date-range-picker-mobile-modal.component';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { SvgIconComponent } from '@components/svg-icon/svg-icon.component';
import { LetDirective } from '@directives/app-let.directive';
import { DateRangePickerService } from '../date-range-picker.service';
import { DATE_FORMAT_DAY_SPACE_SHORT_MONTH_NAME } from '@constants/date-format.constants';
import { FALLBACK_CULTURE } from '@constants/app.constants';

@Component({
  selector: 'app-date-range-picker-mobile',
  standalone: true,
  imports: [
    CommonModule,
    DateRangePickerMobileModalComponent,
    SvgIconComponent,
    LetDirective,
    SvgIconComponent,
  ],
  templateUrl: './date-range-picker-mobile.component.html',
  styleUrl: './date-range-picker-mobile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateRangePickerMobileComponent {
  @Input() datePlaceholder = '';
  @Input() headerTitle = '';
  @Input() confirmButtonText = '';
  @Input() skipButtonText = '';
  @Input() skipText = '';
  @Input() withSkip = false;

  private modalService = inject(ModalService);
  private dateRangePickerService = inject(DateRangePickerService);

  readonly DATE_FORMAT_DAY_SPACE_SHORT_MONTH_NAME =
    DATE_FORMAT_DAY_SPACE_SHORT_MONTH_NAME;
  readonly FALLBACK_CULTURE = FALLBACK_CULTURE;

  firstDateFromRange$ = this.dateRangePickerService.firstDateFromRange$;
  lastDateFromRange$ = this.dateRangePickerService.lastDateFromRange$;
  isSkipped$ = this.dateRangePickerService.isSkipped$;
  isSingleDate$ = this.dateRangePickerService.isSingleDate$;
  culture$ = this.dateRangePickerService.culture$;

  datePickerModalMobileRef?: BsModalRef<DateRangePickerMobileModalComponent>;

  onOpenMobileModal() {
    this.dateRangePickerService.activeInput$.next(null);
    this.updateScrollToMonthId();
    this.openDatePickerMobileModal();
  }

  private openDatePickerMobileModal() {
    this.datePickerModalMobileRef = this.modalService.show(
      DateRangePickerMobileModalComponent,
      {
        class: 'modal-dialog-fullscreen modal-dialog--no-border',
        initialState: {
          headerTitle: this.headerTitle,
          confirmButtonText: this.confirmButtonText,
          skipButtonText: this.skipButtonText,
          withSkip: this.withSkip,
        },
      },
    );
  }

  private updateScrollToMonthId() {
    const date = this.dateRangePickerService.firstDateFromRange$.getValue();
    const formattedDate = date ? `month-${date.toISO({format: 'basic'})?.slice(0, 6)}` || null : null;
    this.dateRangePickerService.scrollToMonthId$.next(formattedDate);
  }
}
